import Script from 'next/script';
const IntrackLoader = () => {
  return <Script id="intrack" strategy="beforeInteractive" defer data-sentry-element="Script" data-sentry-component="IntrackLoader" data-sentry-source-file="IntrackLoader.tsx">
      {`var inTrack_config = {
            app_key: 'AAABEw',
            auth_key: 'c55a82e2-53f1-484d-9a25-7ceaaa5fd087',
            public_key: 'BBm5snC1jayBepHzSnA0JKFxbz58bDTVt-qkXbEWnBqzTVJwwLXYVy24H9_CcWW7PdhBaIbSLFUg8AwSFcM7eYw='
        };
        (function (i, n, t, r, a, c, k) {
            o = i['InTrack'] = i['InTrack'] || {}; i[a] = i[a] || function () { (o.q = o.q || []).push(arguments); };
            s = n.createElement(t); s.async = true; s.src = r; s.onload = function () { o.init(c) };
            e = n.getElementsByTagName(t)[0]; e.parentNode.insertBefore(s, k);
        })(window, document, 'script', "//static1.intrack.ir/api/web/download/sdk/v1/inTrack.min.js?v=00", "Intk", inTrack_config);`}
    </Script>;
};
export default IntrackLoader;